try {
    window.FilePond = require('filepond')
    window.FilePondPluginFileValidateType = require('filepond-plugin-file-validate-type')
    window.FilePondPluginFileValidateSize = require('filepond-plugin-file-validate-size')
} catch (e) {
    console.error(e)
}
